'use client';

import { Button, DialogFooter, ScrollArea } from '@shared/components/shadcn';
import { Affordability } from '@shared/icons/system';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';

const WelcomeStep = () => {
  const t = useTranslations('global_dialogs.affordability_questionnaire');
  const { goToNextStep } = useMultistepForm();

  return (
    <div className="flex min-h-0 flex-1 flex-col pt-10 md:pt-6">
      <ScrollArea className="flex min-h-0 flex-1 flex-col gap-4">
        <Affordability size="extra-extra-large" data-testid="affordability-questionnaire-icon" />
        <h4 className="mb-2 mt-3">{t('welcome.heading')}</h4>
        <div className="space-y-2">
          <span className="block paragraph text-foreground-subtle">{t('welcome.message_intro')}</span>
          <span className="block paragraph text-foreground-subtle">{t('welcome.message_body')}</span>
        </div>
      </ScrollArea>
      <DialogFooter data-track-container="Actions">
        <Button onClick={goToNextStep} data-testid="start-button" data-track-name="Continue">
          {t('welcome.start_button')}
        </Button>
      </DialogFooter>
    </div>
  );
};

export { WelcomeStep };
